export default __webpack_public_path__ + "static/media/team-banner-img.95939085.png";